import { Box } from "@mui/material";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number | string;
  value: number | string;
}

export function TabPanel(props: TabPanelProps) {
  const { children, value, index } = props;
  if (value !== index) return <></>;
  return <>{children}</>;
}
